module.exports = __webpack_public_path__ + "static/media/plate.12511532.jpg";